import {
    UserWorkspaceRole,
    userWorkspaceRolesInOrder,
} from "@common/userWorkspaceRoles";
import { useActiveWorkspaceRole } from "./useActiveWorkspaceRole";

export function useHasAtLeastRole(minimumRequiredRole: UserWorkspaceRole) {
    const workspaceRole = useActiveWorkspaceRole();

    return (
        !!workspaceRole &&
        userWorkspaceRolesInOrder.indexOf(workspaceRole) <=
            userWorkspaceRolesInOrder.indexOf(minimumRequiredRole)
    );
}
